import React, { Component } from 'react';
import Col from '../base-components/Col'

interface ComponentOuterDivProps {
    dataGridField:boolean;
    /** used for datagrid col */
    width?: string;
    /** used for non datagrid col */
    xs?:string, sm?:string, md?:string, lg?:string;
}
class ComponentOuterDiv extends Component<ComponentOuterDivProps,{}> {

    constructor (props: ComponentOuterDivProps) {
        super(props)
    }

    render() {
        let divWidth = this.props.width;
        let {xs, sm, md, lg} = this.props;

        return (this.props.dataGridField ?
            <div style={{"width":divWidth}}>
                {this.props.children}
            </div> :
            <Col xs={xs} sm={sm} md={md} lg={lg}>
                {this.props.children}
            </Col>
            );
    }
}


export default ComponentOuterDiv;
